<style lang="scss" scopped>
.container {
  max-width: 1200px;
}
</style>
<template>
  <v-container class="px-5 py-5 container" fluid>
    <slot></slot>
  </v-container>
</template>

<script>
export default {
  name: "container",
};
</script>